export default __webpack_public_path__ + "static/39-fit-cc82b1e2856be3e6f64aa7bbf8fbc374.png";